import React, { Fragment } from "react";

import { useHistory } from "react-router-dom";

import HelpLoginText from "./help-login-text";
import HelpSearch from "./help-search";
import "./help.scss";
import { useCommonContext } from "../../context/common-context";
import CaretDefault from "../icons/caret-default.svg";
import ChatImg from "../icons/chatnew.svg";
import ContactImg from "./icons/contact.svg";

import Faq from "../faq/faq";

import { BreadCrumb } from "../../common/breadcrumb";
import { routes } from "./constants";

const HelpWrapper = ({
  breadCrumb,
  children,
  faqList,
  faqRoute = null,
  showTitle = true,
  showAll = false,
  showChat = true,
  showSurvey = true,
  showPartialChat = true
}) => {
  const {
    user,
    appData: { banner },
    isGuest,
    isFeedbackAllowed,
  } = useCommonContext();

  const list = JSON.parse(JSON.stringify(faqList));
  let topList = list;
  if (!showAll) {
    const faq = [61, 65, 7].map((index) => list.find((li) => li.id === index));
    topList = faq.filter((list) => list);
  }

  const history = useHistory();
  const handleSeeAll = () => {
    history.push("/" + routes.foryou);
  };
  const handleContactSeeAll = React.useCallback(() => {
    history.push("/contactus");
  });

  const handleChatbot = () => {
    analyticsLinkClick("ohc|chat-initiation");
    try {
      Inq.fireCustomEvent("fireChatNowClicked");
      analyticsLinkClick("ohc|chat-initiation-success");
      $("#tcChat_txtInput_input")[0].focus();
    } catch (e) {
      analyticsLinkClick("ohc|chat-failed");
    }
  };

  const breadCrumblist = [
    {
      label: "Contact Us",
    },
  ];

  const analyticsLinkClick = (link) => {
    if (AB && AB.DATALAYER) {
      AB.DATALAYER.setLinkClickEvents(link);
    }
  };
  return (
    <div className="help-wrapper">
      <BreadCrumb list={breadCrumb || breadCrumblist} />
      {showTitle ? <HelpSearch isGuest={isGuest} banner={banner} /> : null}

      {isGuest && <HelpLoginText />}
      {children}
      <div className="row mt-2">
        <div class="btn col-auto text-left">
          <h3 className="font-weight-600 mt-0">
            {showAll ? "Here are other order related questions" : "Top FAQs"}
          </h3>
        </div>
        <div className="col pl-0">
          {!showAll ? (
            <button
              onClick={handleSeeAll}
              className="btn font-weight-600 homepage-nav link m-auto font-size-16"
              aria-label="Top FAQs View All"
            >
              {" "}
              View All
            </button>
          ) : null}
        </div>
      </div>
      <Faq faq={topList} defaultRoute={faqRoute} />
      {showChat ? (
        <div className="container-md mb-5 mt-3 px-0">
          <div className="row p-md-5 no-gutters">
          {showPartialChat && <div className="col-md-6 d-flex">
              <img height="46" src={ChatImg} alt="Chat with us" />
              <div className="pl-2">
                <h4 className="font-weight-600">Chat with us</h4>
                <h5 className="mb-0 mb-md-auto">
                  {" "}
                  We’ll start with some questions and get you to the right
                  place.
                </h5>
                <button
                  className="btn chevron-icon chat-now pt-2 font-weight-bold cursor-pointer float-right float-md-none mb-2 mb-md-auto"
                  onClick={() => handleChatbot()}
                >
                  Chat now <img className="ml-2" src={CaretDefault} />
                </button>
              </div>
            </div>}
            <div className="col-md-6 d-flex mb-4">
              <img
                height="46"
                src={ContactImg}
                alt="Other ways to contact us"
              />
              <div className="pl-2">
                <h4 class="font-weight-600">Other ways to contact us</h4>
                <h5 className="mb-0 mb-md-auto">
                  Submit a request form, call us or mail us any questions or
                  concerns.
                </h5>
                <button
                  className="btn chevron-icon chat-now pt-2 font-weight-bold cursor-pointer float-right float-md-none"
                  onClick={() => handleContactSeeAll()}
                  aria-label="See all contact us"
                  role="link"
                >
                  See all <img className="ml-2" src={CaretDefault} />
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
        {showSurvey && isFeedbackAllowed && <Fragment><p className="text-center mt-n5">By making your voice heard, you help us improve this page.</p>
        <div className="col-lg-3 col-md-4 col-sm-12 mb-4 mx-auto"><a href="https://forms.office.com/r/emAvYmfhay" target="_black">
          <button type="button" className="btn btn-block feedback-btn px-3 rounded-pill font-weight-600">Give us your feedback</button>
        </a></div></Fragment>}

      {/* <div id="nuance-chat-fixed-1"></div> */}
      <div id="nuance-chat-fixed-ohc"></div>
    </div>
  );
};

export default HelpWrapper;
